import { Card } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  iconClassName?: string;
  iconContainerClassName?: string;
  progress?: number;
  trend?: {
    value: number;
    isPositive: boolean;
  };
}

export const StatCard = ({
  title,
  value,
  icon: Icon,
  iconClassName = "h-6 w-6",
  iconContainerClassName = "p-4 bg-primary/10 rounded-full",
  progress,
  trend,
}: StatCardProps) => {
  return (
    <Card className="p-5 stat-card overflow-hidden relative group">
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 to-accent/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      <div className="relative">
        <div className="flex items-center justify-between space-x-4">
          <div className="space-y-2">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="text-2xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              {value}
            </p>
            {trend && (
              <p className={`text-sm mt-1 flex items-center gap-1 ${
                trend.isPositive ? 'text-success' : 'text-destructive'
              }`}>
                {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
              </p>
            )}
          </div>
          <div className={`${iconContainerClassName} transition-transform duration-300 group-hover:scale-110`}>
            <Icon className={`${iconClassName} transition-colors duration-300`} />
          </div>
        </div>
        {progress !== undefined && (
          <div className="mt-4">
            <div className="h-2 bg-muted rounded-full overflow-hidden">
              <div
                className="h-2 bg-gradient-to-r from-primary to-accent rounded-full transition-all duration-500"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};